"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function CollegeProgramsEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultServices = [
    { title: "Undergraduate", description: "Bachelor's degrees in Engineering, Business, Arts, and Sciences.", icon: "graduation" },
    { title: "Postgraduate", description: "Master's programs designed to advance your career with specialized knowledge.", icon: "certificate" },
    { title: "Doctoral Research", description: "Ph.D. programs pushing the boundaries of knowledge in collaboration.", icon: "research" },
    { title: "Professional Development", description: "Executive education and certification programs for professionals.", icon: "briefcase" },
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Academic Programs"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Programs List</h4>
            <ListItemEditor
              label="Programs"
              items={content.services || defaultServices}
              itemSchema={[
                { key: "title", label: "Program Title", type: "text" },
                { key: "description", label: "Description", type: "text" },
                { key: "icon", label: "Icon (graduation, certificate, research, briefcase)", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, services: items })}
              addItemText="Add Program"
            />
          </div>
        </div>
      }
    />
  );
}
